"use client"

import { Button, Container, Divider, Stack, Typography } from "@mui/material"
import { Link } from "@tc/ui-dfe/components"
import useCloudWatch from "@tc/ui-rum/hooks/useCloudWatch"
import { useEffect } from "react"

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const { logClientEvent } = useCloudWatch()

  useEffect(() => {
    logClientEvent("application_error", {
      message: error?.message || "Unknown error",
      digest: error?.digest || null,
      stack: error?.stack?.slice(0, 500) || null,
    })
  }, [error, logClientEvent])

  return (
    <Stack sx={{ width: "100%" }} alignItems="center" justifyContent="center">
      <Container fixed sx={{ width: "580px", textAlign: "center" }}>
        <Stack
          spacing={2}
          direction="row"
          alignItems="center"
          justifyContent="center"
          divider={<Divider flexItem orientation="vertical" />}
          sx={{
            mt: -5,
            mb: 4,
          }}
        >
          <Typography
            variant="h5"
            data-testid="error"
            component={"strong"}
            color="text.disabled"
          >
            Error
          </Typography>
          <Typography variant="h6" data-testid="errorContent">
            Service unavailable, please try again shortly.
          </Typography>
        </Stack>

        <Link href="/" prefetch custom>
          <Button data-testid="goHomeBtn" variant="contained">
            Go Home
          </Button>
        </Link>
      </Container>
    </Stack>
  )
}
